import { LioTablePagination } from '@components/table/TablePagination';
import { Grid } from '@mui/material';

export type FooterSlotProps = {
  onChangeRowsPerPage: any;
  slotsConfig: any;
  onChangePage: any;
  rowsPerPage: number;
  currentPage: number;
  totalItemCount: number;
  rowsPerPageOptions?: number[];
};

export const FooterSlot = ({
  totalItemCount,
  currentPage,
  rowsPerPage,
  onChangeRowsPerPage,
  slotsConfig,
  onChangePage,
  rowsPerPageOptions,
}: FooterSlotProps) => {
  return (
    <Grid
      container
      sx={{
        borderTop: '1px solid gray',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingY: 1,
      }}
    >
      <Grid ml={1}>{slotsConfig?.Pagination?.actionButton}</Grid>
      <Grid>
        <LioTablePagination
          onRowsPerPageChange={onChangeRowsPerPage}
          onPageChange={(e, page) => {
            onChangePage(page);
          }}
          count={totalItemCount ?? 0}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          page={currentPage}
          component='div'
        />
      </Grid>
    </Grid>
  );
};
